import { FC, Suspense, lazy } from 'react';
import { XmSpinner } from 'src/component/spinner/XmSpinner';
import { CHANGE_TRACKER_SECTIONS } from 'src/content/tools/confChanges/changeTrackerMenu';
import { RoutePath } from 'src/data/Routes';
import { RouteToolSections } from 'src/routing/RouteToolSections';

const ChangeTrackerPage = lazy(() => import('src/content/tools/confChanges/ChangeTrackerPage'));

// One element for every section keeps the page mounted while switching sections
const PAGE = <Suspense fallback={<XmSpinner />}><ChangeTrackerPage /></Suspense>;

export const RouteChangeTracker: FC = () => (
  <RouteToolSections
    rootPath={RoutePath.EVENTS}
    title='Change Tracker'
    sections={CHANGE_TRACKER_SECTIONS}
    renderSection={() => PAGE}
  />
);
